module.exports = function() {
  return new Worker(__webpack_public_path__ + "db10aa88bedf2b001d2f.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/workers/LoadManifestWorker.js
// module id = fJom
// module chunks = 1